import React, { Component } from "react";
import "./Selector.css";

class SelectDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOptions: false,
    };
  }

  handleOnOptionClick = (value) => {
    if (this.props.value !== value && this.props.onChange) {
      this.props.onChange(value);
    }
    this.setState({
      showOptions: false,
    });
  };

  handleOnSelectedClick = () => {
    this.setState({
      showOptions: true,
    });
  };

  hideDropdown = () => {
    this.setState({
      showOptions: false,
    });
  };

  registerCurrentValue = (currentValueElement) => {
    this.currentValueElement = currentValueElement;
  };

  buildLabel = (option, isSelector) => {
    if (option && option.labelComponent) {
      let labelComponent = option.labelComponent;
      let labelComponentWithProps;
      if (labelComponent) {
        labelComponentWithProps = React.cloneElement(labelComponent, {
          ...this.props,
          isSelector,
          ...labelComponent.props,
        });
      }

      return labelComponentWithProps;
    } else {
      return option ? option.label : null;
    }
  };

  render() {
    const { options, value } = this.props;

    if (this.props.readOnly) {
      const currentOption = options
        ? options.find((o) => o.value === value)
        : null;
      return (
        <div className="rp-widget select-dd ro">
          <span className="current-value">
            {this.buildLabel(currentOption, true)}
          </span>
        </div>
      );
    } else {
      const currentOption = options
        ? options.find((o) => o.value === value)
        : null;
      return (
        <div
          className="rp-widget select-dd"
          tabIndex="0"
          onBlur={this.hideDropdown}
        >
          <span
            className={"current-value" + (this.props.error ? " error" : "")}
            ref={this.registerCurrentValue}
            onClick={this.handleOnSelectedClick}
          >
            {this.props.icon ? (
              <span className={"fa fa-" + this.props.icon} />
            ) : null}
            {currentOption
              ? this.buildLabel(currentOption, true)
              : this.props.placeholder}
          </span>
          {this.state.showOptions ? (
            <div className="options-container">
              <div className="tip" />
              <div className="options-scroll-container">
                {options.map((o) => {
                  return (
                    <div
                      key={o.value}
                      className={
                        "option" + (o.value === value ? " selected" : "")
                      }
                      onClick={() => this.handleOnOptionClick(o.value)}
                    >
                      {this.buildLabel(o)}
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
      );
    }
  }
}

class Selector extends Component {
  render() {
    const { value, options, onChange, placeholder } = this.props;

    return (
      <SelectDropdown
        placeholder={placeholder}
        value={value}
        options={options}
        onChange={onChange}
      />
    );
  }
}

export default Selector;



// WEBPACK FOOTER //
// ./src/components/Selector.web.js